/**
 * Herbaleafs Newsletter Popup - JavaScript
 * 
 * Features:
 * - Native Shopify Form Submission (kein fetch)
 * - Bestätigungsansicht nach Reload (Double Opt-In Hinweis)
 * - Cookie-basierte Frequenzkontrolle
 * - Exit-Intent Detection
 * - Mobile-optimiert
 * - Analytics Events (GA4, Meta Pixel)
 */

(function() {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================
  
  var CONFIG = {
    cookieName: 'herbaleafs_newsletter_popup',
    emailCookieName: 'herbaleafs_newsletter_email',
    popupSelector: '#herbaleafs-newsletter-popup',
    formSelector: '#newsletter-popup-form',
    closeSelector: '.hl-popup-close',
  };

  // ============================================
  // HELPER FUNCTIONS
  // ============================================

  var Cookie = {
    set: function(name, value, days) {
      var expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + expires.toUTCString() + ';path=/';
    },
    
    get: function(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    
    exists: function(name) {
      return this.get(name) !== null;
    },

    remove: function(name) {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
    }
  };

  var Analytics = {
    track: function(eventName, eventData) {
      eventData = eventData || {};
      if (typeof gtag !== 'undefined') {
        gtag('event', eventName, eventData);
      }
      if (typeof fbq !== 'undefined') {
        fbq('track', eventName, eventData);
      }
      if (typeof ShopifyAnalytics !== 'undefined') {
        ShopifyAnalytics.lib.track(eventName, eventData);
      }
      console.log('[Analytics]', eventName, eventData);
    }
  };

  // ============================================
  // POPUP CLASS
  // ============================================

  function NewsletterPopup() {
    this.popup = document.querySelector(CONFIG.popupSelector);
    if (!this.popup) return;

    this.form = this.popup.querySelector(CONFIG.formSelector);
    this.closeBtn = this.popup.querySelector(CONFIG.closeSelector);
    this.overlay = this.popup;
    
    this.delay = parseInt(this.popup.dataset.delay) * 1000 || 5000;
    this.cookieDays = parseInt(this.popup.dataset.cookieDays) || 30;
    this.exitIntentEnabled = this.popup.dataset.exitIntent === 'true';
    
    this.exitIntentTriggered = false;
    
    this.init();
  }

  // ============================================
  // INIT
  // ============================================

  NewsletterPopup.prototype.init = function() {
    // -----------------------------------------------
    // FALL 1: Seite wurde nach Newsletter-Anmeldung
    // neu geladen (?customer_posted=true in der URL)
    // → Sofort Bestätigungsansicht zeigen
    // -----------------------------------------------
    if (this.isPostSignup()) {
      this.bindCloseEvents();
      this.showConfirmation();
      this.cleanUrl();
      Analytics.track('newsletter_signup', { source: 'popup' });
      return;
    }

    // -----------------------------------------------
    // FALL 2: Normaler Seitenaufruf
    // -----------------------------------------------
    if (Cookie.exists(CONFIG.cookieName)) {
      return;
    }

    if (window.location.pathname === '/pages/newsletter-danke') {
      return;
    }

    this.bindCloseEvents();
    this.bindFormEvents();
    
    if (this.exitIntentEnabled) {
      this.setupExitIntent();
    } else {
      this.showAfterDelay();
    }
    
    Analytics.track('popup_loaded', {
      delay: this.delay,
      exit_intent: this.exitIntentEnabled
    });
  };

  // ============================================
  // POST-SIGNUP DETECTION
  // ============================================

  NewsletterPopup.prototype.isPostSignup = function() {
    var params = new URLSearchParams(window.location.search);
    return params.has('customer_posted');
  };

  NewsletterPopup.prototype.cleanUrl = function() {
    if (window.history && window.history.replaceState) {
      var url = window.location.pathname + window.location.hash;
      window.history.replaceState(null, '', url);
    }
  };

  // ============================================
  // EVENT BINDING
  // ============================================

  NewsletterPopup.prototype.bindCloseEvents = function() {
    var self = this;

    this.closeBtn.addEventListener('click', function() {
      self.close();
    });
    
    this.overlay.addEventListener('click', function(e) {
      if (e.target === self.overlay) {
        self.close();
      }
    });
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && self.popup.classList.contains('active')) {
        self.close();
      }
    });
  };

  NewsletterPopup.prototype.bindFormEvents = function() {
    var self = this;

    /**
     * Beim Submit: E-Mail im Cookie merken, dann
     * das Formular ganz normal nativ absenden lassen.
     * Shopify macht den Redirect, die Seite lädt neu,
     * und init() erkennt ?customer_posted=true.
     */
    this.form.addEventListener('submit', function(e) {
      var emailInput = self.form.querySelector('#popup-email');
      var email = emailInput ? emailInput.value : '';

      if (!self.validateEmail(email)) {
        e.preventDefault();
        self.showError('Bitte gib eine gültige E-Mail-Adresse ein.');
        return;
      }

      // E-Mail im Cookie speichern, damit wir sie nach
      // dem Reload in der Bestätigungsansicht anzeigen können
      Cookie.set(CONFIG.emailCookieName, email, 1);

      // Cookie setzen, damit das normale Popup nicht mehr erscheint
      Cookie.set(CONFIG.cookieName, 'subscribed', self.cookieDays);

      // Loading-State anzeigen (kurz sichtbar vor dem Redirect)
      self.setLoading(true);

      // KEIN e.preventDefault() → Formular wird nativ abgeschickt
    });
  };

  // ============================================
  // SHOW / CLOSE
  // ============================================

  NewsletterPopup.prototype.showAfterDelay = function() {
    var self = this;
    setTimeout(function() {
      self.show();
    }, this.delay);
  };

  NewsletterPopup.prototype.setupExitIntent = function() {
    var self = this;
    if (!this.isMobile()) {
      document.addEventListener('mouseleave', function(e) {
        if (e.clientY <= 0 && !self.exitIntentTriggered) {
          self.exitIntentTriggered = true;
          self.show();
        }
      });
    } else {
      this.showAfterDelay();
    }
  };

  NewsletterPopup.prototype.show = function() {
    this.popup.style.display = 'flex';
    this.popup.offsetHeight; // reflow für Animation
    this.popup.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    Analytics.track('popup_shown', {
      trigger: this.exitIntentTriggered ? 'exit_intent' : 'delay'
    });
  };

  NewsletterPopup.prototype.close = function(submitted) {
    this.popup.classList.remove('active');
    
    var popup = this.popup;
    setTimeout(function() {
      popup.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
    
    Cookie.set(CONFIG.cookieName, 'closed', this.cookieDays);
    
    Analytics.track('popup_closed', { submitted: !!submitted });
  };

  // ============================================
  // CONFIRMATION VIEW (nach Reload)
  // ============================================

  NewsletterPopup.prototype.showConfirmation = function() {
    var content = this.popup.querySelector('.hl-popup-content');
    var email = Cookie.get(CONFIG.emailCookieName) || '';
    var self = this;

    // E-Mail-Cookie aufräumen
    Cookie.remove(CONFIG.emailCookieName);

    // E-Mail-Anzeige vorbereiten
    var emailHtml = '';
    if (email) {
      emailHtml = ' an <strong>' + this.escapeHtml(email) + '</strong>';
    }

    content.innerHTML =
      '<div class="hl-confirmation">' +
        '<div class="hl-confirmation-icon">' +
          '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">' +
            '<path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />' +
          '</svg>' +
        '</div>' +
        '<h2 class="hl-popup-title">Schön, dass du dabei bist!</h2>' +
        '<p class="hl-popup-text">Bitte bestätige deine Anmeldung, indem du jetzt auf den Link in der E-Mail klickst, die wir dir gerade' + emailHtml + ' gesendet haben.</p>' +
        '<p class="hl-confirmation-hint">Du findest keine E-Mail? Schau bitte auch in deinem Spam-Ordner nach.</p>' +
        '<button type="button" class="hl-btn-primary hl-btn-close-confirm">Alles klar</button>' +
      '</div>';
    
    content.querySelector('.hl-btn-close-confirm').addEventListener('click', function() {
      self.close(true);
    });

    // Popup sofort anzeigen (kein Delay)
    this.show();
  };

  // ============================================
  // HELPERS
  // ============================================

  NewsletterPopup.prototype.validateEmail = function(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  NewsletterPopup.prototype.escapeHtml = function(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  };

  NewsletterPopup.prototype.setLoading = function(loading) {
    var btn = this.form.querySelector('.hl-btn-primary');
    if (!btn) return;
    var btnText = btn.querySelector('.hl-btn-text');
    var btnLoading = btn.querySelector('.hl-btn-loading');
    
    btn.disabled = loading;
    if (btnText) btnText.style.display = loading ? 'none' : 'inline';
    if (btnLoading) btnLoading.style.display = loading ? 'inline-flex' : 'none';
  };

  NewsletterPopup.prototype.showError = function(message) {
    var errorMsg = this.form.querySelector('.hl-form-error');
    if (!errorMsg) return;
    if (message) {
      var span = errorMsg.querySelector('span');
      if (span) span.textContent = message;
    }
    errorMsg.style.display = 'flex';
  };

  NewsletterPopup.prototype.isMobile = function() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  // ============================================
  // INITIALIZE
  // ============================================

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      new NewsletterPopup();
    });
  } else {
    new NewsletterPopup();
  }

})();